import { useMutation } from '@tanstack/react-query'

import { sendMFAMessageCode } from '../services/send-MFA-message-code.service'

export function useSendMFAMessageCode() {
  return useMutation({
    mutationFn: sendMFAMessageCode,
  })
}
